



















































import Vue from 'vue'
import { Component, Prop, Emit, Watch } from 'vue-property-decorator'
import { dateTimeToParse, monthToParse, monthToDisplay, todayToParse, dateTimeToUnix, dateToDisplay } from '@/utils/dateTime'

@Component
export default class AppDatePicker extends Vue {
  @Prop({ type: [Number, String] }) readonly value!: number | string
  @Prop(String) readonly label!: string
  @Prop({ type: String }) readonly placeholder!: string
  @Prop({ type: String, default: '1900-01-01' }) readonly startDate!: string
  @Prop({ type: String }) readonly endDate!: string
  @Prop({ type: Boolean, default: false }) readonly required!: boolean
  @Prop({ type: [Number, String], default: 289 }) readonly width!: number | string
  @Prop({ type: [Number, String], default: 36 }) readonly height!: number | string
  @Prop({ type: String, default: 'date' }) readonly type!: string
  @Prop({ type: Boolean, default: false }) readonly isShowList!: boolean
  @Prop({ type: String, default: '' }) readonly className!: string
  @Prop({ type: String, default: '' }) readonly inlineLabel!: string
  @Prop({ type: Boolean, default: false }) readonly returnTimeStamp!: boolean
  @Prop({ type: Boolean, default: true }) readonly isShowFormatText!: boolean
  @Prop({ type: Boolean, default: false }) readonly isShowLabel!: boolean
  @Prop({ type: Boolean, default: true }) readonly isListClass!: boolean

  model = ''
  viewModel = ''

  show = false

  rules = {
    required: (value: string) => !!value || 'Required.',
    onlyDate: (value: string) => {
      const valArr = value.split('/')
      if (valArr.length > 3) {
        return 'Invalid Date'
      }
      const dateStr = this.type === 'month'
        ? (valArr[1] || '1900') + '-' + (valArr[0] || '01')
        : (valArr[2] || '1900') +
          '-' +
          (valArr[0] || '01') + '-' +
          (valArr[1] || '01')

      const valid = this.$moment(dateStr).isValid()
      return valid || 'Invalid Date'
    }
  }

  top = 0
  left = 0

  nowDate = todayToParse()

  mounted () {
    if (!this.value) {
      return
    }
    if (this.type === 'month') {
      this.model = monthToParse(this.returnTimeStamp ? Number(this.value) : this.value)
    } else {
      this.model = dateTimeToParse(this.returnTimeStamp ? Number(this.value) : this.value)
    }
  }

  @Watch('value')
  onValueChanged (val: string) {
    if (!val) {
      this.model = ''
      return
    }
    if (this.type === 'month') {
      if (this.returnTimeStamp) {
        this.model = this.$moment.unix(this.returnTimeStamp ? Number(val) : val).tz('America/New_York').format('YYYY-MM')
      } else {
        this.model = this.$moment(val).tz('America/New_York').format('YYYY-MM')
      }
    } else {
      this.model = this.returnTimeStamp
        ? this.$moment.unix(Number(val)).tz('America/New_York').format('YYYY-MM-DD')
        : val
    }
  }

  @Watch('model')
  onModelChanged (val: string) {
    if (!val) {
      this.viewModel = ''
      return
    }
    if (this.type === 'month') {
      this.viewModel = this.$moment(val).format('MM/YYYY')
    } else {
      this.viewModel = this.$moment(val).format('MM/DD/YYYY')
    }
  }

  @Emit('input')
  valueChangedHandler (val: string) {
    this.model = val
    if (this.returnTimeStamp) {
      return dateTimeToUnix(val).toString()
    } else {
      return val
    }
  }

  @Emit()
  submit () {
    // do nothing
  }

  @Emit('search')
  searchHandler () {}

  blurHandler () {
    if (!this.viewModel || this.rules.onlyDate(this.viewModel) !== true) {
      this.clearModel()
      return
    }

    const valArr = this.viewModel.split('/')
    if (valArr[0].length === 1) {
      valArr[0] = '0' + valArr[0]
    }

    if (this.type === 'month') {
      if (!valArr[1] || valArr[1].length < 4) {
        valArr[1] = this.$moment().get('year')
      }
      this.valueChangedHandler(`${valArr[1]}-${valArr[0]}`)
    } else {
      if (!valArr[1]) {
        valArr[1] = '01'
      } else if (valArr[1].length === 1) {
        valArr[1] = '0' + valArr[1]
      }

      if (!valArr[2] || valArr[2].length < 4) {
        valArr[2] = this.$moment().get('year')
      }

      this.valueChangedHandler(`${valArr[2]}-${valArr[0]}-${valArr[1]}`)
    }
  }

  handleMonthSelected (val: string) {
    if (this.type === 'month') {
      this.valueChangedHandler(val)
    }
  }

  handlefocus () {
    const pickerIcon = this.$refs.pickerIcon as Vue & {
      getBoundingClientRect: () => any;
    }
    this.top = pickerIcon.getBoundingClientRect().y - 100
    this.left = pickerIcon.getBoundingClientRect().x - 266
    this.show = true
  }

  allowedDates (val: string) {
    const endDate = this.endDate
      ? this.$moment(this.endDate)
      : this.$moment()
    const startDate = this.startDate
      ? this.$moment(this.startDate)
      : this.$moment('1900-01-01')
    const isBefore = this.$moment(val).isAfter(this.$moment(startDate))
    const isAfter = this.$moment(val).isBefore(endDate)
    return isBefore && isAfter
  }

  clearModel () {
    this.model = ''
    this.show = false
    this.valueChangedHandler(this.model)
    this.searchHandler()
  }

  confirmHandler () {
    this.show = false
    this.searchHandler()
  }
}
